export default {
  index: [
    {
      path: '/deepseek',
      component: resolve => require(['./index.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/deepseek/_router.js